import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider, FieldArray } from "formik";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import $ from "jquery";
const DecayLoadingEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
   const [permission, setPermission] = useState({});
 
  const [backendErrors, setBackendErrors] = useState([]);
  const [customersList, setCustomersList] = useState([]);  
  const [productLists, setproductLists] = useState([]);
  // const [showTableHeadings, setShowTableHeadings] = useState(true);
  const [valuecontents, setValuecontents] = useState([]);
  
   let season_id = localStorage.getItem("season_id");

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const formik = useFormik({
    initialValues: {
      id: value.id,
      season_id:season_id,
      date: value.date,
      product: value?.item?.product || "",
      quantity: value?.item?.quantity || "",
      driver_plate_number: value.driver_plate_number,
      decay_customer: value.decay_customer,
      note: value.note,
      items:valuecontents
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values , { setSubmitting }) => {
      axios
        .post("/decay-sale-loadings/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
         
          delete backendErrors['error'];
          setSubmitting(false);
          // actions.setSubmitting(false);
          $("#form-submit").text("Update Sale Loading");
           if (response.data.code === 200) {
             toast.success(response.data.message);
          //   actions.resetForm();
             setTimeout(() => {
               window.location.href = "/decay-loading";
             }, 1000);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(450)); 
      console.log(permission);
   
    axios
      .get(`/decay-sale-loadings/edit/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.sale);
          
          setValuecontents(response.data.data.sale.items);
         
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
  }, [id]);

  useEffect(() => {
 
    
    axios
    .post(
      "/products/listing-category-type",
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.products;
        let productslisting = products.map((customer, index) => ({
          label: customer.productname,
          value: customer.id,
          key: `address-${index}`,
        }));
        setproductLists(productslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

      
    axios
    .post(
      "/decay-customers/listing", {},
      {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.customers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.id,
          key: `categories-${index}`,
        }));
        setCustomersList(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });


}, []);
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  
  
  
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

    const deleteItemFromDB = (item_id) => {
      const  response_data = {};
      response_data.status = 'false';
      axios.get(`/decay-loadings/delete-item/${season_id+'-'+item_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          response_data.status = 'ok';
          return response_data;
        }
      }).catch((error) => {
        console.log(error);

        response_data.status = 'false';
      
      });
      return response_data;
    };

 

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Decay Loading</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/decay-loading">Decay Loading</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Decay Loading Info</h4>
                    {permission && permission.update == 1 && (
                    <FormikProvider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                      
                    
                    <div className="row">
                    <div className="col-md-6">
                          <div className="form-group">
                          <label>Date</label>
                             
                             <input
                               type="date"
                               className="form-input form-control"
                               name="date"
                               value={formik.values.date}
                               onChange={(e) => {
                                 formik.handleChange(e);
                                 customHandleInput(e);
                                
                               }}
                               onBlur={formik.handleBlur}
                              
                             />
                              <small>
                                {backendErrors.date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                       
                                               
                                {/* <div className="col-md-6">
                                    <div className="form-group status">
                                        <label>Select Product</label>
                                        <Select
                                        className="w-100"
                                        value={productLists.find(option => option.value == formik.values.product) || null} // Ensure correct format
                                        name="product"
                                          onChange={(selectedOption) => handleSelectChange("product", selectedOption)}
                                        onBlur={formik.handleBlur}
                                        options={productLists}
                                        placeholder="Select"
        
                                          
                                        />
                                        <small>
                                          {backendErrors.product && (
                                              <span className="form-error mt-1">
                                                {backendErrors.product}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                  </div> */}
                                  
                        
                        
                        <div className="col-md-6">
                          <div className="form-group status">
                              <label>Select Decay Customer</label>
                              {customersList.length > 0 && (
                                <Select
                                className="w-100"
                              value={customersList.find(option => option.value == formik.values.decay_customer) || null} // Ensure correct format
                              name="decay_customer"
                               onChange={(selectedOption) => handleSelectChange("decay_customer", selectedOption)}
                              onBlur={formik.handleBlur}
                              options={customersList}
                              placeholder="Select"

                               
                              />
                              )}
                              
                              <small>
                                {backendErrors.decay_customer && (
                                    <span className="form-error mt-1">
                                      {backendErrors.decay_customer}
                                    </span>
                                  )}
                              </small>
                            </div>
                        </div>

                        {/* <div className="col-md-6">
                            <div className="form-group">
                                <label>Quantity</label>
                                <input
                                  type="number"
                                  name="quantity"
                                  value={formik.values.quantity}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Enter Quantity"
                                />
                                <small>
                                  {backendErrors.quantity && (
                                      <span className="form-error mt-1">
                                        {backendErrors.quantity}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div> */}

                          <div className="col-md-6">
                            <div className="form-group">
                                <label>Driver Plate Number</label>
                                <input
                                  type="text"
                                  name="driver_plate_number"
                                  value={formik.values.driver_plate_number}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Enter Driver Plate Number"
                                />
                                <small>
                                  {backendErrors.driver_plate_number && (
                                      <span className="form-error mt-1">
                                        {backendErrors.driver_plate_number}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>

                        <div className="col-md-6">
                        <div className="form-group">
                            <label>Note</label>
                            <input
                              type="text"
                              name="note"
                              value={formik.values.note}
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.note && (
                                  <span className="form-error mt-1">
                                    {backendErrors.note}
                                  </span>
                                )}
                            </small>
                          </div>
                        </div>
                     

                      </div>
            <FieldArray
                        name="items"
                        render={(arrayHelpers) => (
                          <div style={{overflow:"auto2"}}>
                             <button
                              className="btn btn-primary mb-3"
                              type="button"
                              onClick={() => {
                                //let appendArr =arrayHelpers.form.values.items[0];
                                let initialArr ={
                                  product: "",
                                  quantity: "",
                                  original_quantity: "",
                                 }
                                 //appendArr = (appendArr)?appendArr:initialArr;
                                arrayHelpers.push(initialArr);
                               
                               
                              }}
                            >
                              +
                            </button> 

                            <table className="table table-padding">
                                <thead>
                                  <tr>
                                  <th>Product</th>
                                    <th>Net Weight</th>
                                    <th>Original Net Weight</th>
                                    <th></th>
                                 
                                  </tr>
                                </thead>
                             
                              <tbody>
                                {formik.values.items.map(
                                  (friend, index) => (
                                    <tr key={index}>
                                    
                                      <td  >
                                        <div className="form-group status">
                                        {productLists.length > 0 && (
                                          <Select
                                          name={`items[${index}].product`}
                                          options={productLists}
                                          value={productLists.find(option => option.value == formik.values.items[index].product) || null} // Ensure correct format
                                          onChange={(selectedOption) => {
                                            formik.setFieldValue(`items[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                            customHandleInput({
                                              target: {
                                                name: `items[${index}].product`,
                                                value: selectedOption.value, // ✅ Ensure only value is passed
                                              },
                                            });
                                          }}
                                          onBlur={formik.handleBlur}
                                          placeholder="Select"
                                          className="w-100"
                                        />
                                         )}
                                          
                                        </div>
                                      </td>
                                   
                                      <td >
                                        <div className="form-group">
                                        
                                          <div className="input-group" >
                                              <input type="text"  
                                              name={`items[${index}].quantity`}
                                              onKeyPress={(event) => {
                                                // Prevent non-numeric input for keypress
                                                if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              value={
                                                formik.values.items[index]
                                                  .quantity
                                              }
                                            
                                              onChange={(e) => {
                                                formik.handleChange(e);
                                              }}
                                              onBlur={formik.handleBlur}
                                              className="form-control" placeholder="Net Weight" />
                                            
                                          </div>
                                        </div>
                                      </td>
                                      <td >
                                        <div className="form-group">
                                        
                                          <div className="input-group" >
                                              <input type="text"  
                                              name={`items[${index}].original_quantity`}
                                              onKeyPress={(event) => {
                                                // Prevent non-numeric input for keypress
                                                if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              value={
                                                formik.values.items[index]
                                                  .original_quantity
                                              }
                                            
                                              onChange={(e) => {
                                                formik.handleChange(e);
                                              }}
                                              onBlur={formik.handleBlur}
                                              className="form-control"  placeholder="Original Net Weight" />
                                              
                                          </div>
                                        </div>
                                      </td>
                                     
                                      <td >
                                        <div className="form-group">
                                         
                                           <button
                                              className="btn btn-danger"
                                               type="button"
                                             
                                              onClick={() =>{
                                                let item_record = formik.values.items[index];
                                                if(item_record.id == undefined){
                                                  arrayHelpers.remove(index)
                                                }else{
                                                  deleteItemFromDB(item_record.id);
                                                  arrayHelpers.remove(index)
                                                }
                                              } }
                                            >
                                              -
                                            </button>
                                            {index === formik.values.items.length - 1 && (
                                                <button
                                                    className="btn btn-primary "
                                                    type="button"
                                                    id="add-barcode-button2"
                                                    onClick={async () => {
                                                      //let appendArr =arrayHelpers.form.values.items[0];
                                                        let initialArr ={
                                                          product: "",
                                                          quantity: "",
                                                          original_quantity: "",
                                                        }
                                                        //appendArr = (appendArr)?appendArr:initialArr;
                                                        arrayHelpers.push(initialArr);
                                                      
                                                    }}
                                                  >
                                                    +
                                                  </button>
                                              )} 
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      />

                      <div className="text-end mt-4">
                        <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                        Update Decay Loading
                        </button>
                      </div>
                    </form>
                  </FormikProvider>
                )}
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DecayLoadingEdit;
